import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import TrueFalseHandles from '../../components/TrueFalseHandles';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

export default function IsExternalNode(): React.ReactElement {
  const translate = useTranslate();

  return (
    <NodeWrapper>
      <NodeHeader icon={<NodeIcon name='is_external' />} title={translate('callflows.nodes.is_external.name')} />
      <Handle type='target' position={Position.Left} id='is_external-target' />
      <TrueFalseHandles />
    </NodeWrapper>
  );
}
